var ProductGallery = /** @class */ (function () {
    function ProductGallery() {
        this.selectors = {
            container: '[data-product-gallery]',
            featuredImg: '[data-product-gallery-featured-img] img',
            item: '[data-product-gallery-item]',
            itemImg: '[data-product-gallery-item] img'
        };
        this.nodeList = {
            containers: document.querySelectorAll(this.selectors.container)
        };
    }
    ProductGallery.prototype.init = function () {
        var _this = this;
        this.nodeList.containers.forEach(function (container) {
            var items = container.querySelectorAll(_this.selectors.itemImg);
            items.forEach(function (item) {
                item.addEventListener('click', _this.handleItemClick.bind(_this, container));
            });
        });
    };
    ProductGallery.prototype.handleItemClick = function (container, event) {
        this.updateFeaturedImg(event.currentTarget, container);
    };
    ProductGallery.prototype.updateFeaturedImg = function (img, container) {
        var featuredImg = container.querySelector(this.selectors.featuredImg);
        featuredImg.src = img.src;
        featuredImg.srcset = img.srcset;
    };
    return ProductGallery;
}());
export { ProductGallery };
;
